import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PendingApprovalComponent} from "./components/pending-approval/pending-approval.component";
import {MatCardModule} from "@angular/material/card";
import { LoaderEmitterComponent } from './components/loader-emitter/loader-emitter.component';
import { ConfirmContractSigningComponent } from './components/confirm-contract-signing/confirm-contract-signing.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import { SignContractComponent } from './components/sign-contract/sign-contract.component';
import { CustomSelectComponent } from './components/forms/custom-select/custom-select.component';



@NgModule({
  declarations: [
    PendingApprovalComponent,
    LoaderEmitterComponent,
    ConfirmContractSigningComponent,
    SignContractComponent,
    CustomSelectComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    PendingApprovalComponent,
    LoaderEmitterComponent,
    CustomSelectComponent
  ]
})
export class UtilityModule { }
